import { WebSocketManager } from "../../../helpers/webSocketManager";
import localScaleManager from "../../../helpers/LocalScaleManager";
import { tweenConfigs } from "../../../helpers/tweensConfigs";

export class TimeBank extends Phaser.GameObjects.Sprite {
  constructor(scene, table) {
    super(scene, 0, 0, scene.atlasTexture, "time-bank-1");
    this.scene = scene;
    this.table = table;
    this.scaleTweenDuration = 50;
    this.scene.add.existing(this);
    this.table.poolArray.push(this);

    this.setInteractive({ cursor: "pointer" });
    this.on("pointerdown", this.scaleTween, this);
    this.on("pointerout", this.unscaleTween, this);
    this.on("pointerup", this.onClick, this);
    this.isShowing = false;
    this.btnClicked = false;
    this.initScale = 1;

    this.timerText = this.scene.add
      .bitmapText(0, 0, "digital", "+00:00")
      .setOrigin(0);
    this.timerText.setData("width", this.timerText.width);
    this.timerText.setData("height", this.timerText.height);
    this.table.poolArray.push(this.timerText);

    // this.table.poolArray.push(this.animation);
    this.play("time-bank-blink");
  }
  scaleTween() {
    if (this.btnClicked) return;
    this.btnClicked = true;
    if (this.scene.tweenEnable) {
      this.scene.tweens.add({
        targets: this,
        duration: this.scaleTweenDuration,
        ease: "Linear",
        scale: this.scale * 0.9,
      });
    }
  }
  unscaleTween() {
    this.btnClicked = false;
    if (this.scene.tweenEnable) {
      this.scene.tweens.add({
        targets: this,
        duration: this.scaleTweenDuration,
        ease: "Linear",
        scale: this.initScale,
        onComplete: () => {
          this.scale = this.initScale;
        },
      });
    }
  }
  async onClickTween() {
    return new Promise((resolve) => {
      if (this.scene.tweenEnable) {
        this.scene.tweens.add({
          targets: this,
          duration: 200,
          ease: "Linear",
          scale: this.initScale,
          onComplete: () => {
            this.scale = this.initScale;
            resolve();
          },
        });
      } else {
        resolve();
      }
    });
  }
  // async onClick() {
  //   let eventAddress = "";
  //   await this.onClickTween();
  //   const data = {
  //     tableId: this.table.tableInfo.id,
  //   };
  //   this.disableInteractive();
  //   eventAddress = "poker.client-push.time-bank";
  //   WebSocketManager.emitEvent(data, eventAddress)
  //     .then(() => {
  //       this.setInteractive();
  //       if (this.scene.alertify)
  //         this.scene.alertify.typeSuccess("Time bank was initiated for you.");
  //       this.hide();
  //     })
  //     .catch(() => {
  //       this.setInteractive();
  //     });
  // }
  async onClick() {
    let eventAddress = "";
    this.disableInteractive();
    await this.onClickTween();
    this.btnClicked = false;
    const data = {
      tableId: this.table.tableInfo.id,
    };
    let timeout = setTimeout(() => {
      this.setInteractive();
    }, 3000);
    eventAddress = "poker.client-push.time-bank";
    WebSocketManager.emitEvent(data, eventAddress)
      .then(() => {
        if (this.scene.alertify)
          this.scene.alertify.typeSuccess("Time bank was initiated for you.");
        this.hide();
      })
      .finally(() => {
        this.setInteractive();
        clearTimeout(timeout);
        timeout = null;
      });
  }
  updateText(time) {
    this.timerText.setText(
      `+${new Date(time * 1000).toISOString().substr(14, 5)}`
    );
    this.timerText.setX(this.x - this.timerText.width / 2);
  }

  show(playerInfo) {
    this.isClicked = false;
    if (!this.visible) this.setVisible(true);
    this.updateText(playerInfo.timeBank);
    if (!this.timerText.visible) this.timerText.setVisible(true);
    this.isShowing = true;
    this.setScale(this.initScale);
    if (this.scene.tweenEnable) {
      if (this.anims && this.anims.isPaused) {
        this.anims.resume();
      }
      // this.scene.tweens.add({
      //   targets: this,
      //   duration: tweenConfigs.actionButtons.show.duration,
      //   ease: tweenConfigs.actionButtons.show.ease,
      //   y: this.btnInitY,
      //   onComplete: () => {
      //     this.y = this.btnInitY;
      //   },
      // });
      // this.alarmTween = this.scene.tweens.add({
      //   targets: this,
      //   duration: 500,
      //   ease: "Back",
      //   // y: `-=${this.displayHeight / 3}`,
      // angle: {
      //   duration: 200,
      //   yoyo: true,
      //   repeat: -1,
      //   ease: "Bounce",
      //   value: {
      //     getStart: function (
      //       target,
      //       key,
      //       value,
      //       targetIndex,
      //       totalTargets,
      //       tween
      //     ) {
      //       // console.log(value);
      //       return value > 0 ? -30 : 30;
      //     },
      //     getEnd: function (
      //       target,
      //       key,
      //       value,
      //       targetIndex,
      //       totalTargets,
      //       tween
      //     ) {
      //       return 0;
      //     },
      //   },
      // },
      //   texture: "",
      //   onComplete: () => {},
      //   yoyo: true,
      //   repeat: -1,
      // });
    } else {
      // this.y = this.btnInitY;
    }
  }
  hide() {
    // this.alarmTween.paused = true;
    // if(!this.alarmTween.isPaused()) this.alarmTween.pause();
    this.isShowing = false;
    // if (this.alarmTween) this.scene.tweens.remove(this.alarmTween);
    // if (this.scene.tweenEnable) {
    //   this.scene.tweens.add({
    //     targets: this,
    //     duration: tweenConfigs.actionButtons.hide.duration,
    //     ease: tweenConfigs.actionButtons.hide.ease,
    //     y: this.scene.gameHeight + this.displayHeight * 3,
    //     onComplete: () => {
    //       this.angle = 0;
    //       this.y = this.scene.gameHeight + this.displayHeight * 3;
    //       // this.setVisible(false);
    //     },
    //   });
    // } else {
    if (this.anims && this.anims.isPlaying) {
      this.anims.pause();
    }
    if (this.visible) this.setVisible(false);
    if (this.timerText.visible) this.timerText.setVisible(false);
    //   this.y = this.scene.gameHeight + this.displayHeight * 3;
    // }
  }
  /***
   * @param  initX {number} x of table
   * @param  initY {number} y of table
   * @param width {number} table.displayWidth
   * @param height {number} table.displayHeight
   */
  positionControls(initX, initY, width, height) {
    let btnSize = width * 0.26;
    localScaleManager.scaleSprite(this, btnSize, btnSize, 0, 1, true);
    this.setPosition(initX + width * 0.285, initY + height * 0.84);
    this.btnInitY = this.y;
    this.initScale = this.scale;

    this.textSize = this.displayWidth / 2;
    localScaleManager.scaleBitMapText(
      this.timerText,
      this.displayWidth * 0.75,
      this.displayHeight * 0.25,
      0,
      1,
      false
    );
    this.timerText.setPosition(
      this.x - this.timerText.width / 2,
      this.y + this.timerText.height / 4
    );
    this.hide(false);
    // this.show();
    // setTimeout(() => this.hide(), 5000)
  }
  /***
   * @param  initX {number} x of table
   * @param  initY {number} y of table
   * @param width {number} table.displayWidth
   * @param height {number} table.displayHeight
   */
  reposition(initX, initY, width, height) {
    this.setPosition(initX + width * 0.285, initY + height * 0.84);
    this.btnInitY = this.y;
    this.timerText.setPosition(
      this.x - this.timerText.width / 2,
      this.y + this.timerText.height / 4
    );
  }
  remove() {
    this.destroy();
  }
}
